export const EMPTY_VALUE_PLACEHOLDER = "-";

/**
 * Cria um formatador base usando a API nativa do browser.
 * Isso garante performance e localização correta.
 */
export function createNumberFormatter(
  decimals: number = 2,
  options?: Intl.NumberFormatOptions,
  locales?: Intl.LocalesArgument
) {
  return new Intl.NumberFormat(locales, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    ...options,
  });
}

/**
 * Função utilitária para lidar com valores nulos ou indefinidos
 * Comum em dashboards quando o sensor cai.
 */
export function safeFormat(
  value: number | undefined | null,
  formatter: Intl.NumberFormat,
  fallback: string = EMPTY_VALUE_PLACEHOLDER
): string {
  if (value === undefined || value === null || isNaN(value)) {
    return fallback;
  }
  return formatter.format(value);
}

export function safeFormatParts(
  value: number | null,
  formatter: Intl.NumberFormat,
  unit: string
) {
  const formattedValue = safeFormat(value, formatter);
  return {
    value: formattedValue,
    unit,
  };
}

export function partsToString(parts: { value: string; unit: string }) {
  return `${parts.value} ${parts.unit}`.trim();
}
